<ion-app>
  <ion-header *ngIf="mobileTabFlag"></ion-header>
  <ion-router-outlet></ion-router-outlet>
</ion-app>